import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { NavLink, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

const capitalizeFirst = (s = "") => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "");

@withTranslation()
@withRouter
class Tab extends React.Component {
    constructor(props) {
        super(props);
        this.onTabClick = this.onTabClick.bind(this);
    }

    onTabClick(e) {
        const { onSelect, onClick, val } = this.props;
        if (onSelect) {
            e.preventDefault();
            onSelect(val);
        }
        if (onClick) onClick(val);
    }

    getDisplayLabel() {
        const { t, val, name, classPropName } = this.props;

        const hasCustomName = typeof name === "string" && name.trim() !== "";
        const base = hasCustomName ? name : t(`tabs.${val}`);

        const shouldCapitalize = classPropName === "search-grid-tab" || hasCustomName;

        return shouldCapitalize ? capitalizeFirst(base) : base.toUpperCase();
    }

    render() {
        const { val, history, counter, getPath, classPropName } = this.props;

        const aPath = history.location.pathname.split("/");
        aPath.pop();
        aPath.push(val);
        const path = getPath ? getPath() : aPath.join("/");

        return (
            <NavLink exact to={path} className={cx("tab-vertical", classPropName)} onClick={this.onTabClick}>
                {this.getDisplayLabel()} {counter}
            </NavLink>
        );
    }
}

Tab.propTypes = {
    val: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    t: PropTypes.func,
    classPropName: PropTypes.string,
    name: PropTypes.string,
    counter: PropTypes.node,
    getPath: PropTypes.func,
    onSelect: PropTypes.func,
    onClick: PropTypes.func,
    card: PropTypes.object,
    role: PropTypes.object,
};

export default Tab;
